import React, { FC, useState } from 'react';
import { Button, Form, Modal as AntModal } from 'antd';

type Props = {
  title: string;
  ModalForm: any;
  onCreate: Function;
  bindActionButtons?: boolean;
};

const CreationModal: FC<Props> = ({ title, onCreate, ModalForm, bindActionButtons = false }) => {
  const [visible, setVisible] = useState(false);
  const [form] = Form.useForm();

  return (
    <>
      <Button onClick={() => setVisible(true)}>{title}</Button>
      <AntModal
        title={title}
        visible={visible}
        {...(bindActionButtons
          ? {
              okText: 'Create',
              onOk: () => {
                form
                  .validateFields()
                  .then(async values => {
                    const success = await onCreate(values);
                    if (success) {
                      form.resetFields();
                      setVisible(false);
                    }
                  })
                  .catch(info => {
                    console.log('Validate Failed:', info);
                  });
              }
            }
          : {
              footer: null
            })}
        onCancel={() => setVisible(false)}
      >
        <ModalForm
          {...(bindActionButtons ? { form } : { onCreate, closeModal: () => setVisible(false) })}
          layout={'horizontal'}
          labelCol={{ span: 6 }}
          wrapperCol={{ span: 14 }}
        />
      </AntModal>
    </>
  );
};

export default CreationModal;
